import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PaymentStatus from './pages/PaymentStatus';
import Payment from './pages/Payment';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsService from './pages/TermsService';
import AccountDeletion from './pages/AccountDeletion';
import Credits from './pages/messagecredit/Credits';
import Biometric from './pages/biometric/Biometric';
import WhatsAppSettings from './pages/whatsapponnboarding/WhatsappSetting';
import WASubscriptionPayment from './pages/subscrption/WASubscriptionPayment';


function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/payment-status" element={<PaymentStatus />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/tos" element={<TermsService />} />
      <Route path="/accountdelete" element={<AccountDeletion />} />
      <Route path="/credits" element={<Credits />} />
      <Route path="/bio" element={<Biometric />} />
      <Route path="was" element={<WASubscriptionPayment/>} />
      <Route path="/whatsappsignup" element={<WhatsAppSettings />} />
    </Routes>
  );
}

export default App;